module.exports = __webpack_public_path__ + "img/builder-29.c59779b1.webp";